import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../api/axios";

const LABELS = { photo: "Photo", nid: "NID" };

/**
 * The photo and NID uploaded for a booking. They are private files: the browser cannot open them with a
 * plain link, so each one is fetched through the API (with the sign-in token) and opened from a blob.
 */
export default function BookingDocuments({ bookingId }) {
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    let cancelled = false;
    api
      .get(`/api/bookings/${bookingId}/documents`)
      .then((res) => {
        if (!cancelled) setDocuments(res.data?.documents || []);
      })
      .catch(() => {
        if (!cancelled) setDocuments([]);
      });
    return () => {
      cancelled = true;
    };
  }, [bookingId]);

  const openDocument = async (doc) => {
    try {
      const res = await api.get(`/api/bookings/${bookingId}/documents/${doc.id}`, {
        responseType: "blob",
      });
      const url = URL.createObjectURL(res.data);
      window.open(url, "_blank", "noopener");
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      toast.error("Could not open this document.");
    }
  };

  if (documents.length === 0) return null;

  return (
    <div className="card border-0 shadow-sm mb-4">
      <div className="card-body">
        <h4 className="text-primary border-bottom pb-2 mb-3">Documents</h4>
        <div className="d-flex flex-wrap gap-2">
          {documents.map((doc) => (
            <button
              key={doc.id}
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={() => openDocument(doc)}
            >
              {LABELS[doc.document_type] || doc.document_type}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
